import { SelectMode } from 'src/app/components/multiple-select/multiple-select.component';
import {
    DashboardItemComponentType,
    DashboardItemFactory,
    IDashboardItemFactoryOptions,
} from 'src/app/utils/dashboard-item';
import { DatasourceColumnId } from 'src/app/utils/datasource-sql-map/datasource';
import { IFilterCategoryDashboardItem } from './category-filter-dashboard-item.component';

export class FilterCategoryDashboardItemFactoryOptions implements IDashboardItemFactoryOptions {
    excludeMode?: boolean;
    splitable?: boolean;
    /** True if this filter can be used as a breakdown "bucket"/group dimension (opt-in, default false). */
    bucketable?: boolean;
    /** Single or multiple select mode
     * @default 'multiple'
     */
    selectMode?: SelectMode;
    /**
     * Show the navigation '<' and '>' buttons
     * @default false
     */
    showQuickSelectionButtons?: boolean;
    constructor(
        /** Instance id */
        public createdInstanceId: string,
        public datasourceColumnId: DatasourceColumnId
    ) {}
}

export class FilterCategoryDashboardItemFactory extends DashboardItemFactory<
    IFilterCategoryDashboardItem,
    FilterCategoryDashboardItemFactoryOptions
> {
    override FACTORY_CLASS: string = 'FilterCategoryDashboardItemFactory';
    override COMPONENT_CLASS: DashboardItemComponentType =
        'CategoryFilterDashboardItem';

    override getInstance(options: FilterCategoryDashboardItemFactoryOptions) {
        const categoryFilter: IFilterCategoryDashboardItem = {
            datasourceColumnId: options.datasourceColumnId,
            instanceId: options.createdInstanceId,
            dashboardItem: {
                id: options.datasourceColumnId,
                initialState: {
                    value: [],
                    split: false,
                    isFilterApplied: false,
                    isSplitApplied: false,
                },
            },
            component: 'CategoryFilterDashboardItem',
            composeData: (data) => {
                // if data is empty return empty array
                if (!data.length) {
                    return [];
                }
                // const pivotResult = pivotTable<any>(data);
                // TODO replace('.', '_') should be unnecessary. Check it.
                // const selectOptions =
                //     pivotResult[options.datasourceColumnId.replace('.', '_')];
                // console log datasourceColumnId and selectOptions as one object
                // console.log({ datasourceColumnId: options.datasourceColumnId, selectOptions });
                return data;
            },
            splitable: options.splitable ?? true,
            bucketable: options.bucketable ?? false,
            excludeMode: options.excludeMode ?? true,
            selectMode: options.selectMode ?? 'multiple',
            showQuickSelectionButtons:
                options.showQuickSelectionButtons ?? false,
        };

        return categoryFilter;
    }
}
